import {Component, OnInit, ViewChild} from '@angular/core';
import {VotingService} from "../../services/voting.service";
import {VoteModel} from "../../models/vote.model";
import {VoteSectionComponent} from "./components/vote-section/vote-section.component";
import {SettingsService} from '../../services/settings.service';
import {Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-vote-page',
  templateUrl: './vote-page.component.html',
  styleUrls: ['./vote-page.component.scss']
})
export class VotePageComponent implements OnInit {
  senateVotes: VoteModel[] = [];
  councilVotes: VoteModel[] = [];
  loading = false;
  votingEnabled = false;
  @ViewChild('senateSection')
  senateSection: VoteSectionComponent;
  @ViewChild('councilSection')
  councilSection: VoteSectionComponent;

  constructor(
    readonly votingService: VotingService,
    private readonly _settingsService: SettingsService,
    private readonly _router: Router,
    private readonly _snack: MatSnackBar
  ) { }

  async ngOnInit(): Promise<void> {
    const enabledSetting = await this._settingsService.getBySlug('vote-enabled').toPromise();
    this.votingEnabled = enabledSetting.enabled;
  }

  addSenateVotes(votes: VoteModel[]): void {
    this.senateVotes = votes;
  }

  addCouncilVotes(votes: VoteModel[]): void {
    this.councilVotes = votes;
  }

  get totalLength(): number {
    return this.senateVotes.length + this.councilVotes.length;
  }

  async sendVotes(): Promise<void> {
    this.loading = true;
    try {
      const votes = [...this.senateVotes, ...this.councilVotes];
      const res = await this.votingService.vote(votes).toPromise();
      this.loading = false;
      this._snack.open(res, 'Close');
      this.reset();
    } catch (err: any) {
      this.loading = false;
      if (err.status === 400) {
        this._snack.open(err.error, 'Close');
      }
    }
  }

  reset(): void {
    this.senateVotes = [];
    this.councilVotes = [];
    this.senateSection.count = 0;
    this.senateSection.votes = [];
    this.councilSection.count = 0;
    this.councilSection.votes = [];
    this.senateSection.cardInputs.forEach(c => {
      c.voted = false;
    });
    this.councilSection.cardInputs.forEach(c => {
      c.voted = false;
    });
  }
}
